import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { UiRoutes } from '@lsq-frontend/angular-shared/app-constants';
import { NoEulaGuard } from '@lsq-frontend/fasttrack-shared/features/eula-service';
import {
    enrollmentNode,
    factoringNode,
    rootAtlas,
    settingsNode,
    supplyChainDirectNode,
    supplyChainPlatformNode
} from '@lsq-frontend/fasttrack-shared/routing-atlas';
import { AuthorizationGuard, ClaimGuard, EnvironmentsGuard } from '@lsq-frontend/common-ui';
import { Routes } from '@lsq-frontend/common-ui';
import { AppDashboardRootGuard } from '../app-dashboard/app-dashboard-root.guard';
import { AppDashboardComponent } from '../app-dashboard/app-dashboard.component';
import { SwitchAccountComponent } from '../identity/switch-account/switch-account.component';
import { MobileUploadTokenComponent } from '../invoices/upload-invoices/mobile-upload-invoices/mobile-upload-token.component';
import { RegistrationRedirectComponent } from '../supply-chain-registration/supply-chain-registration-redirect.component';
import { FasttrackMonolithEntryComponent } from './entry.component';

export const appRoutes: Routes = [
    {
        path: '',
        component: FasttrackMonolithEntryComponent,
        children: [
            {
                path: rootAtlas.SELECT_ACCOUNT.path,
                component: SwitchAccountComponent,
                canActivate: [AuthorizationGuard, NoEulaGuard],
                data: {
                    title: rootAtlas.SELECT_ACCOUNT.title
                }
            },
            {
                path: rootAtlas.LOCAL.path,
                loadChildren: () =>
                    import('../local-management/local-management.module').then(
                        (m) => m.LocalManagementModule
                    ),
                canActivate: [EnvironmentsGuard],
                data: {
                    environments: rootAtlas.LOCAL.environments
                }
            },
            {
                path: rootAtlas.ADMIN.path,
                loadChildren: () => import('../admin/admin.module').then((m) => m.AdminModule),
                canActivate: [AuthorizationGuard, NoEulaGuard, ClaimGuard],
                data: {
                    claims: rootAtlas.ADMIN.claims
                }
            },
            {
                path: settingsNode.path,
                loadChildren: () =>
                    import('../settings/settings.module').then((m) => m.SettingsModule),
                canActivate: [AuthorizationGuard, NoEulaGuard]
            },
            {
                path: 'supply-chain-supplier-enrollment',
                component: RegistrationRedirectComponent
            },
            {
                path: enrollmentNode.path,
                data: { skipPreload: true },
                loadChildren: () =>
                    import('../enrollment/enrollment.module').then((m) => m.EnrollmentModule)
            },
            {
                path: rootAtlas.MOBILE_UPLOAD_TOKEN.path,
                component: MobileUploadTokenComponent,
                data: {
                    title: rootAtlas.MOBILE_UPLOAD_TOKEN.title
                }
            },
            {
                path: rootAtlas.VIEW_DOCUMENTS.path,
                loadChildren: () =>
                    import('../documents/documents.module').then((m) => m.DocumentsModule),
                canActivate: [AuthorizationGuard]
            },
            {
                path: supplyChainPlatformNode.path,
                loadChildren: () =>
                    import('../supply-chain/platform/supply-chain-platform.module').then(
                        (m) => m.SupplyChainPlatformModule
                    )
            },
            {
                path: UiRoutes.Home,
                component: AppDashboardComponent,
                children: [
                    {
                        path: supplyChainDirectNode.path,
                        loadChildren: () =>
                            import('../supply-chain/direct/supply-chain-direct.module').then(
                                (m) => m.SupplyChainDirectModule
                            ),
                        canActivate: [AuthorizationGuard, AppDashboardRootGuard]
                    },
                    {
                        path: factoringNode.path,
                        loadChildren: () =>
                            import('../factoring/factoring.module').then((m) => m.FactoringModule),
                        canActivate: [AuthorizationGuard, AppDashboardRootGuard]
                    }
                ]
            },
            {
                path: UiRoutes.Wildcard,
                redirectTo: `/${UiRoutes.NotFound}`,
                pathMatch: 'full'
            }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(appRoutes)],
    exports: [RouterModule]
})
export class FasttrackMonolithEntryRoutingModule {}
